import _ from "underts";
import { functionnal } from "vincent-utils";
import { z } from "zod/v4";
const curry2 = functionnal.curry2.bind(functionnal);
const curry3 = functionnal.curry3.bind(functionnal);
const curry4 = functionnal.curry4.bind(functionnal);
const getEmptyCasesFromFullDayArray = function (dayArray) {
    return dayArray.reduce(function (resultArray, rdvCase) {
        if (rdvCase.tag === "empty") {
            resultArray.push(rdvCase);
        }
        return resultArray;
    }, []);
};
//ne sert à rien ?
// const preventWaste = function (
//   arrayOfEmptyPlagesArrays,
//   dureeCible: number,
//   wasteLength: number,
//   duréeMinRdv: number
// ) {
//   "use strict";
//   return _.filter(arrayOfEmptyPlagesArrays, function (plageArray) {
//     return (
//       plageArray.length - dureeCible / duréeMinRdv !== wasteLength / duréeMinRdv
//     );
//   });
// };
//prend un tableau de cases vides et renvoie toutes les combinaisons possibles en fonction de la durée donnée
const getCandidatePlagesFromEmptyArray = function (emptyRdvArray, duree, duréeMinRdv) {
    let cases, casesArray, length, index, tempArray;
    cases = duree / duréeMinRdv;
    casesArray = [];
    length = emptyRdvArray.length;
    index = 0;
    if (!z.number().int().safeParse(cases).success) {
        throw new Error("duree must be a multiple of duréeMinRdv in getCandidatePlagesFromEmptyArray");
    }
    for (index; index < length - cases + 1; index++) {
        tempArray = [];
        tempArray = emptyRdvArray.slice(index, index + cases);
        casesArray.push(tempArray);
    }
    return casesArray;
};
const areContiguousCases = function (previousCase, currentCase, duréeMinRdv) {
    "use strict";
    var intervale;
    if (previousCase && currentCase) {
        intervale =
            currentCase.hour * 60 +
                currentCase.minute -
                (previousCase.hour * 60 + previousCase.minute);
        if (intervale === duréeMinRdv) {
            return true;
        }
    }
};
const testArrayForContiguousCases = function (emptyRdvArray, duréeMinRdv) {
    "use strict";
    var length, index;
    length = emptyRdvArray.length - 1;
    index = 0;
    for (index; index < length; index++) {
        if (!areContiguousCases(emptyRdvArray[index], emptyRdvArray[index + 1], duréeMinRdv)) {
            return false;
        }
    }
    return true;
};
const filterUncontiguousCasesFromResult = function (arrayOfArrays, duréeMinRdv) {
    return arrayOfArrays.filter((arr) => testArrayForContiguousCases(arr, duréeMinRdv));
};
const keepOnlyFirstCaseFromEachContiguousCase = function (arrayOfArrays) {
    return _.compact(arrayOfArrays.map((arr) => _.first(arr)));
};
const convertDayEmptyCasesArrayIntoCandidates = function (emptyCasesArray, duration) {
    "use strict";
    return emptyCasesArray.map(function (rdvCase) {
        return Object.assign({}, {
            duration,
            hour: rdvCase.hour,
            minute: rdvCase.minute,
            date: rdvCase.date,
        });
    });
};
//renvoit les cases vides correspondant à la durée demandée groupées en sous-tableaux
const matchingPlages = (fullDaysWeek, duree, duréeMinRdv) => {
    return fullDaysWeek
        .map(getEmptyCasesFromFullDayArray)
        .map((cases) => getCandidatePlagesFromEmptyArray(cases, duree, duréeMinRdv))
        .map((cases) => filterUncontiguousCasesFromResult(cases, duréeMinRdv));
};
//transforme des groupes de cases vides de la duréeMiniRdv en une seule case par groupe de la durée recherchée
//c'est à dire que les cases vides sont fusionnées en une plage par futur rdv
const plagesToCandidates = (arrayOfWeekPlages, duree) => {
    return arrayOfWeekPlages
        .map(keepOnlyFirstCaseFromEachContiguousCase)
        .map((cases) => convertDayEmptyCasesArrayIntoCandidates(cases, duree));
};
// const getUnfilteredCandidatesFromFullDaysWeeks = function (
//   fullDaysWeeks: DayCase[][],
//   duree: number,
//   duréeMinRdv: number
// ) {
//   "use strict";
//   const emptyCases = fullDaysWeeks.map(getEmptyCasesFromFullDayArray);
//   let candidatesPlages = emptyCases.map(
//     curry2(getCandidatePlagesFromEmptyArray)(duree)(duréeMinRdv)
//   );
//   candidatesPlages = candidatesPlages.map((stuff) =>
//     filterUncontiguousCasesFromResult(stuff, duréeMinRdv)
//   );
//   candidatesPlages = candidatesPlages.map((stuff) =>
//     preventWaste(stuff, duree, duréeMinRdv, duréeMinRdv)
//   );
//   fullDaysWeeks = _.map(fullDaysWeeks, keepOnlyFirstCaseFromEachContiguousCase);
//   fullDaysWeeks = _.map(
//     fullDaysWeeks,
//     curry2(convertDayEmptyCasesArrayIntoCandidates)(duree)
//   );
//   return fullDaysWeeks;
// };
//main export
//prend les cases vides, fermées, remplies de la semaine et renvoie une liste de heure/minute/duree/date, correspondant à toutes les possibilités, en semaines de jours
const getAllCandidates = (fullRdvsDaysWeek, duree, duréeMinRdv) => plagesToCandidates(matchingPlages(fullRdvsDaysWeek, duree, duréeMinRdv), duree);
export { getEmptyCasesFromFullDayArray, getCandidatePlagesFromEmptyArray, matchingPlages, plagesToCandidates, getAllCandidates, };
//# sourceMappingURL=unfilteredCandidates.js.map